import React, { Component } from "react";

export class MasterFooter extends Component {
  render() {
    return (
      <div className="footer">
        <div className="card clearfix">
          <span className="footer-text-left">
            <a href="https://bpmbuild.com/">Developed by BPMBuild</a>
          </span>
          <span className="footer-text-right">
            <span className="ui-icon-copyright" />{" "}
            <span>All Rights Reserved</span>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MasterFooter.js